import { NoOpVisibilityService } from './visibility.service';
import { NoOpIntervalService } from './interval.service';
import { ElementRef, ChangeDetectorRef } from '@angular/core';

import { 
  Component, 
  OnChanges,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef,
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ProgressBarModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintEdi_ShellService } from './FootprintEdi.shell.service';
import { FootprintEdi_OperationService } from './FootprintEdi.operation.service';
import { FootprintEdi_DatasourceService } from './FootprintEdi.datasource.index';
import { FootprintEdi_FlowService } from './FootprintEdi.flow.index';
import { FootprintEdi_FrontendFlowService } from './FootprintEdi.frontend.flow.service';
import { FootprintEdi_ReportService } from './FootprintEdi.report.index';
import { FootprintEdi_LocalizationService } from './FootprintEdi.localization.service';
import { FootprintEdi_home_ComponentContextService } from './FootprintEdi.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './FootprintEdi.frontend.types'
import { $frontendTypes as $types} from './FootprintEdi.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
@Component({
  imports: [
    SharedModule,
  ],
  selector: 'FootprintEdi-home',
  templateUrl: './FootprintEdi.home.component.html'
})
export class FootprintEdi_homeComponent extends BaseComponent {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  formGroup = new FormGroup({
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
  };

  fields = {
  };

  fieldsets = {
};


  $formGroupFieldValidationObservables = {
  }
  

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintEdi_ShellService,
    private $datasources: FootprintEdi_DatasourceService,
    private $flows: FootprintEdi_FlowService,
    private $frontendFlows: FootprintEdi_FrontendFlowService,
    private $reports: FootprintEdi_ReportService,
    private $localization: FootprintEdi_LocalizationService,
    private $operations: FootprintEdi_OperationService,
    private $context: FootprintEdi_home_ComponentContextService,
    elementRef: ElementRef,
    cdr: ChangeDetectorRef,
    private noOpVisibilityService: NoOpVisibilityService,
    private noOpIntervalService: NoOpIntervalService,) { 
    super(elementRef, cdr, noOpVisibilityService, noOpIntervalService);
    this.$subscribeFormControlValueChanges();
  }

  protected override $onInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  protected override $onDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'FootprintEdi';
  
    const $form = this;
    const $utils = this.$utils;



    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
}
